<template>
  <div>
    <popup-add-task ref="popupAddTask" />
    <vs-list>
      <!-- <draggable v-model="tasksToday" group="tasks" @start="drag = true" @end="drag = false"> -->
      <tippy v-for="task in tasksToday" :key="task.venueTaskId">
        <template v-slot:trigger>
          <vs-list-item
            :title="task.title"
            :subtitle="taskSubtitle(task)"
            @click.native="$refs.popupAddTask.showWith(task)"
          >
            <div class="right-icons" vs-justify="flex-end">
              <div vs-w="6" v-if="task.flagged">
                <feather-icon icon="FlagIcon" svgClasses="w-4 h-4 text-warning" />
              </div>
              <div vs-w="6" v-if="task.hasLocation">
                <feather-icon icon="NavigationIcon" svgClasses="w-4 h-4 text-warning" />
              </div>
              <div vs-w="6" v-if="task.hasResponsible">
                <feather-icon icon="UserIcon" svgClasses="w-4 h-4 text-warning" />
              </div>
              <div vs-w="6" v-if="task.hasImage">
                <feather-icon icon="ImageIcon" svgClasses="w-4 h-4 text-warning" />
              </div>
            </div>
            <template slot="avatar">
              <vs-checkbox
                v-model="task.completed"
                @click.native.stop="changeCompleted(task, !task.completed)"
              ></vs-checkbox>
            </template>
          </vs-list-item>
        </template>

        <!-- The information in the tooltip -->
        <div class="popup-container text-left">
          <vs-row>
            <h4 class="task-title">{{ task.title }}</h4>
          </vs-row>
          <vs-row>
            <feather-icon
              v-if="task.flagged"
              class="mr-2"
              icon="FlagIcon"
              svgClasses="w-4 h-4 text-warning"
            />
            <span class="mr-2">{{ moment(task.startDateUtcTicks).format("HH:mm") }}</span>
            <span>{{ task.roleTitle }}</span>
          </vs-row>
          <vs-row v-if="task.hasResponsible" class="my-2">
            <span>Assigned to {{ task.responsibleName }} </span>
          </vs-row>
          <vs-row class="my-2">
            <span>{{ task.note }} </span>
          </vs-row>
          <vs-row>
            <img v-if="task.hasImage" class="task-image" :src="task.imageUrls[0]" />
          </vs-row>
        </div>
      </tippy>
      <!-- </draggable> -->
    </vs-list>
  </div>
</template>

<style scoped></style>

<script>
import draggable from "vuedraggable";
import { RRule, RRuleSet, rrulestr } from "rrule";
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";
import PopupAddTask from "./PopupAddTask.vue";
import "tippy.js/dist/tippy.css";
import tippy from "tippy.js";

export default {
  props: ["tasks", "date", "showCompleted"],
  data() {
    return {
      drag: false,
      roleMap: {
        hq: "Marketing",
        vm: "Venue Manager",
        sm: "Shift Manager",
      },
      moment,
    };
  },
  components: {
    PopupAddTask,
    draggable,
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),
    tasksToday: {
      get() {
        var unsorted = this.tasks
          .filter(e => moment(e.instanceDateUtcTicks).isSame(this.date, "day"))
          .map(e => {
            return {
              ...e,
              // isChecked: _.some(
              //   e.venueTaskCompletedList,
              //   c => moment(c.completedDate).isSame(this.date, "day") && c.venueId === this.activeVenue.venueId
              // ),
              hasLocation: e.address != "",
              hasResponsible: e.responsibleUserId != "",
              hasImage: e.imageUrls.length > 0,
              roleTitle: e.role == "" ? "" : this.roleMap[e.role],
            };
          })
          .filter(e => this.showCompleted || !e.completed);

        return _.sortBy(unsorted, e => e.startDateUtcTicks);
      },
      async set(newList) {
        var oldList = this.tasksToday;
        console.log(oldList, newList);

        var addedElement = _.find(newList, e => !oldList.some(o => o.venueTaskId == e.venueTaskId));
        // var deletedElement = _.find(oldList, e => !newList.some(o => o.venueTaskId == e.venueTaskId));

        if (addedElement) {
          var startBefore = moment(addedElement.instanceDateUtcTicks);

          var newDate = moment(this.date.valueOf(), this.momentFormat);
          newDate.set({
            hour: startBefore.hours(),
            minute: startBefore.minutes(),
          });

          console.log("before", addedElement.instanceDateUtcTicks, startBefore.toDate());
          console.log("after", newDate.toDate());

          // TODO Set end date according to change in start date?

          await this.$store.dispatch("venueTasks/updateVenueTaskDate", {
            id: addedElement.venueTaskId,
            newDate: newDate.format(),
          });
        }
        // if (deletedElement) {
        //   console.log("DELETED", deletedElement);
        // }
      },
    },
    taskSubtitle() {
      return task => {
        var time = moment(task.startDateUtcTicks).format("HH:mm");
        return `${task.roleTitle} ${time}`;
      };
    },
  },
  methods: {
    async changeCompleted(task, newState) {
      const dto = {
        venueTaskId: task.venueTaskId,
        venueId: this.activeVenue.venueId,
        date: this.date.clone().format("YYYY-MM-DD"),
        checked: newState,
      };
      console.log("marking checked", dto);
      var result = await this.$store.dispatch("venueTasks/changeChecked", dto);
      if (result) this.$root.$emit("venueTaskChanged");
    },
  },
};
</script>

<style lang="scss" scoped>
// .vs-row {
//   flex-flow: nowrap; // Can be used to make 7 rows if on card (remember)
// }

.right-icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.popup-container {
  .task-title {
    color: #fff;
  }

  .task-image {
    margin: 14px auto;
    max-width: 100%;
    max-height: 140px;
  }
}

// .right-icons {
//   padding: 0;
//   margin: 0;

//   > * {
//     padding: 0;
//     margin: 0;
//     width: 20px;
//   }
// }

// .v-tooltip__content {
//   pointer-events: auto;
// }
</style>
